export default "__VITE_ASSET__BNLP$U3P__"